/**
 * Chaves de permissão alinhadas ao JWT (campo permissoes).
 */
export const PERMISSIONS = {
  SUPER_ADMINISTRADOR: 'SUPER_ADMINISTRADOR',
  ADMINISTRATIVO: 'ADMINISTRATIVO',
  GESTAO_DEBITO: 'GESTAO_DEBITO',
  DEBITO: 'DEBITO',
  GESTAO_NUCLEO: 'GESTAO_NUCLEO',
  GESTAO_CURSO: 'GESTAO_CURSO',
  GESTAO_TRATAMENTO: 'GESTAO_TRATAMENTO',
  ATENDENTE: 'ATENDENTE',
  TRATAMENTO: 'TRATAMENTO',
  JURIDICO_RELATORIO_FINANCEIRO: 'JURIDICO_RELATORIO_FINANCEIRO',
  USUARIO_CONSULTAR_OCORRENCIA: 'USUARIO_CONSULTAR_OCORRENCIA',
  GESTAO_ASSOCIADO: 'GESTAO_ASSOCIADO',
} as const;

/** Qualquer uma destas libera a rota /debitos/relatorios. */
export const RELATORIOS_FINANCEIROS_PAGE_PERMISSIONS = [
  PERMISSIONS.GESTAO_DEBITO,
  PERMISSIONS.DEBITO,
  PERMISSIONS.ADMINISTRATIVO,
  PERMISSIONS.JURIDICO_RELATORIO_FINANCEIRO,
  PERMISSIONS.GESTAO_TRATAMENTO,
  PERMISSIONS.ATENDENTE,
  PERMISSIONS.TRATAMENTO,
  PERMISSIONS.SUPER_ADMINISTRADOR,
] as const;
